<template>
  <component
    v-bind:is="$route.name === 'manual' ? 'QuestionIndex' : 'QuestionForm'"
    :product="product" />
</template>

<script>
import QuestionForm from '@/components/QuestionForm'
import QuestionIndex from '@/components/QuestionIndex'

export default {
  name: 'Questions',
  props: { product: { type: Object, required: true } },
  components: {
    QuestionForm,
    QuestionIndex
  },
  computed: {
    pageTitle () {
      let title = this.$t(this.$route.name === 'manual' ? 'title_index' : 'title_form')
      return title + ' | ' + this.product.name
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "title_index": "Frequently Asked Questions / FAQ",
    "title_form": "Create new question"
  },
  "pt-BR": {
    "title_index": "Dúvidas Frequentes / FAQ",
    "title_form": "Cadastrar nova pergunta"
  }
}
</i18n>
